import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import MainStore from '../../../MainStore';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import UserSelect from '../Users/UserSelect';
import ServerStore from './ServerStore';
import ProjectSelect from '../Projects/ProjectSelect';
import AccountSelect from '../Kanban/AccountSelect';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Editor } from 'ckeditor5-custom-build/build/ckeditor';
import './serverStyle.css'
import StandTypeSelect from './StandTypeSelect';
import StandCategorySelect from './StandCategorySelect';
import AccessUserList from './AccessUserList';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import AccessProtocolSelect from './AccessProtocolSelect';
import AuthTypeSelect from './AuthTypeSelect';
import EnvironmentTable from './EnvironmentTable';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilePanel from '../File/FilePanel';

const ServerDialog = observer(class ServerDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTab: 0,
            fullscreen: true
        };

        this.handleScroll = this.handleScroll.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    scrollPosition = 0

    componentDidUpdate() {
        this.scrollPosition = window.scrollY;
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleTabChange(event, newValue) {
        this.setState({ selectedTab: newValue });
    }

    handleScroll(event) {
        if (this.scrollPosition !== 0) {
            var pos = this.scrollPosition;
            this.scrollPosition = 0;
            window.scrollTo(0, pos);
        }
    }

    handleClose() {
        if (!ServerStore.openedServer.id) {
            var res = window.confirm("Ты уверен что хочешь закрыть не сохраненную карточку?? Подумай!");
            if (res) {
                this.setState({ selectedTab: 0});
                ServerStore.closeServerDialog();
            }
            else {
                return;
            }
        }
        this.setState({ selectedTab: 0 });
        ServerStore.closeServerDialog();
    }

    handleRowCheckedChange = name => evt => {
        var server = ServerStore.openedServer;
        server[name] = evt.target.checked;
        ServerStore.setOpenedServer(server);
    }

    handleRowDataChange = name => evt => {
        var server = ServerStore.openedServer;
        server[name] = evt.target.value;
        ServerStore.setOpenedServer(server);
    }

    handleDescriptionChange(value) {
        var server = ServerStore.openedServer;
        server.description = value;
        ServerStore.setOpenedServer(server);
    }

    handleLookupChange = name => value => {
        var server = ServerStore.openedServer;
        server[name + "Id"] = value.id;
        server[name + "Name"] = value.name;
        ServerStore.setOpenedServer(server);
    }

    handleSave() {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server',
            JSON.stringify(ServerStore.openedServer)
            ,
            'application/json',
            (result) => {
                MainStore.setMaskUnvisible();
                ServerStore.updateHandler(result);
                ServerStore.closeServerDialog();
            },
            'POST'
        );
    }

    render() {
        return (
            <Dialog
                disableEnforceFocus={true}
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={ServerStore.isServerDialogOpened}
                maxWidth="lg"
                fullWidth
                scroll="paper"
                fullScreen={this.state.fullscreen}
                className={"server-kanban  " + (this.state.fullscreen ? "fullscreen" : "")}
            >
                <DialogTitle id="customized-dialog-title">
                    <div className="server-dialog-number"><CopyToClipboard onCopy={() => { MainStore.openSnackbar('Скопировано в буфер обмена'); }} text={document.location.origin + '/serversBoard?id=' + encodeURIComponent(ServerStore.openedServer.id)}><span>{ServerStore.openedServer.address}</span></CopyToClipboard></div>
                    <div className="server-dialog-caption">
                        <FormControl fullWidth>
                            <InputLabel htmlFor="adornment-caption">Заголовок</InputLabel>
                            <Input
                                id="adornment-caption"
                                value={ServerStore.openedServer.caption}
                                onChange={this.handleRowDataChange('caption')}
                            />
                        </FormControl>
                    </div>
                    <div className="action-button-block">
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={this.handleMenuClick}
                            size="large">
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.isMenuOpen}
                            onClose={this.handleMenuClose}
                            PaperProps={{
                                style: {
                                    maxHeight: 200,
                                    width: 200,
                                },
                            }}
                        >
                            <MenuItem key={0} onClick={this.handleDeleteServer}>
                                Удалить
                            </MenuItem>
                        </Menu>
                        {!this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': true }); }} size="large">
                            <FullscreenIcon />
                        </IconButton>
                        }
                        {this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': false }); }} size="large">
                            <FullscreenExitIcon />
                        </IconButton>

                        }
                        
                        <Button onClick={this.handleSave} color="primary" className="server-dialog-save-button">
                            Сохранить
                         </Button>
                        <IconButton onClick={this.handleClose} size="large">
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <div className="server-dialog-bar clearfix">
                        <AppBar position="static" color="default" className="short-appbar">
                            <Tabs
                                value={this.state.selectedTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label="Главная" />
                                <Tab label="Среды" />
                                {ServerStore.openedServer.id && ServerStore.openedServer.isAccessRestricted && <Tab label="Права доступа" />}
                            </Tabs>
                        </AppBar>
                    </div>
                    {this.state.selectedTab === 0 && <div className="clearfix">
                        <div className="card-inner-block card-inner-block-server">
                            <div className="clearfix">
                                <div className="server-group-block clearfix">
                                    <div className="server-dialog-group-caption">
                                        Классификация
                                    </div>
                                    <div>
                                        <Typography>
                                            <StandTypeSelect name={ServerStore.openedServer.typeName} id={ServerStore.openedServer.typeId} label="Тип сервера" handleSelect={this.handleLookupChange("type")} />
                                        </Typography>
                                        <Typography>
                                            <StandCategorySelect name={ServerStore.openedServer.categoryName} id={ServerStore.openedServer.categoryId} label="Категория сервера" handleSelect={this.handleLookupChange("category")} />
                                        </Typography>
                                    </div>
                                </div>
                                <div className="server-group-block clearfix server-half-block">
                                    <div className="server-dialog-group-caption">
                                        Подключение
                                    </div>
                                    <div>
                                        <div className="server-half-block">
                                            <TextField
                                                required
                                                id="address"
                                                label="Адрес сервера"
                                                variant="standard"
                                                value={ServerStore.openedServer.address}
                                                onChange={this.handleRowDataChange('address')}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                            />
                                            <AccessProtocolSelect name={ServerStore.openedServer.accessProtocolName} id={ServerStore.openedServer.accessProtocolId} label="Протокол подключения" handleSelect={this.handleLookupChange("accessProtocol")} />
                                        </div>
                                        <div className="server-half-block">
                                            <Typography>
                                                <AuthTypeSelect name={ServerStore.openedServer.authTypeName} id={ServerStore.openedServer.authTypeId} label="Тип аутентификации" handleSelect={this.handleLookupChange("authType")} />
                                                <TextField
                                                    id="login"
                                                    label="Имя пользователя"
                                                    variant="standard"
                                                    value={ServerStore.openedServer.login}
                                                    onChange={this.handleRowDataChange('login')}
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                />
                                            </Typography>
                                            <Typography>
                                                <TextField
                                                    id="password"
                                                    label="Пароль"
                                                    variant="standard"
                                                    value={ServerStore.openedServer.password}
                                                    onChange={this.handleRowDataChange('password')}
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                />
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                                <div className="server-group-block clearfix server-half-block">
                                    <div className="server-dialog-group-caption">
                                        Связи
                                    </div>
                                    <div>
                                        <Typography>
                                            <UserSelect name={ServerStore.openedServer.ownerName} label="Ответственный" handleSelect={this.handleLookupChange("owner")} />
                                        </Typography>
                                        <Typography>
                                            <ProjectSelect name={ServerStore.openedServer.projectName} id={ServerStore.openedServer.projectId} handleSelect={this.handleLookupChange("project")} />
                                        </Typography>
                                        <Typography>
                                            <AccountSelect id={ServerStore.openedServer.accountId} name={ServerStore.openedServer.accountName} color={ServerStore.openedServer.accountColor} label="Контрагент" handleSelect={this.handleLookupChange("account")} />
                                        </Typography>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={ServerStore.openedServer.isAccessRestricted} onChange={this.handleRowCheckedChange('isAccessRestricted')} value="true" />
                                            }
                                            label="Использовать ограничение доступа"
                                        />
                                    </div>
                                </div>
                            </div>
                            {ServerStore.openedServer.id && <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Файлы</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <FilePanel key={ServerStore.openedServer.id} workId={ServerStore.openedServer.id} sessionId={ServerStore.openedServer.sessionId} controllerName="Server"/>
                                </AccordionDetails>
                            </Accordion>}
                            <CKEditor
                                editor={Editor}
                                data={ServerStore.openedServer.description}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.handleDescriptionChange(data);
                                }}
                            />
                        </div>
                    </div>}
                    {this.state.selectedTab === 1 && <div className="clearfix">
                        <div className="card-inner-block card-inner-block-server">
                            <EnvironmentTable serverId={ServerStore.openedServer.id} accountId=""/>
                        </div>
                    </div>}
                    {this.state.selectedTab === 2 && <div className="clearfix">
                        <div className="card-inner-block card-inner-block-server">
                            <AccessUserList serverId={ServerStore.openedServer.id} />
                        </div>
                    </div>}
                </DialogContent>
            </Dialog>
        );
    }
});

export default ServerDialog;